<template>
    <div class="view-wrap">
        <div class="view-wrap-item clearfix">
            <div class="wrap-item-label">送货地址：</div>
            <div class="wrap-item-value">
                <p>{{ detail.userName }}&nbsp;{{ detail.userPhone }}</p>
                <p>{{ detail.userAddress }}</p>
            </div>
        </div>
        <div class="view-wrap-item clearfix">
            <div class="wrap-item-label">配送方式：</div>
            <div class="wrap-item-value">
                <p>{{ methodFilter(detail.deliverMethods) }}</p>
            </div>
        </div>
        <div class="view-wrap-item clearfix">
            <div class="wrap-item-label">订单编号：</div>
            <div class="wrap-item-value">
                <p>{{ detail.orderId }}</p>
            </div>
        </div>
        <div class="view-wrap-item clearfix">
            <div class="wrap-item-label">支付方式：</div>
            <div class="wrap-item-value">
                <p>{{ payTypeFilter(detail.orderPayType) }}</p>
            </div>
        </div>
        <div class="view-wrap-item clearfix">
            <div class="wrap-item-label">下单时间：</div>
            <div class="wrap-item-value">
                <p>{{ detail.orderTime }}</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        detail: Object
    },
    computed: {
        pay() {
            return this.$store.state.payType;
        }
    },
    methods: {
        payTypeFilter(value) {
            let row = this.pay.find(item => item.key === value);
            return row ? row.value : '';
        },
        methodFilter(value) {
            switch (value) {
            case 1:
                return '商家承运';
            case 2:
                return '物业配送';
            case 3:
                return '到店自取';
            default:
                return '';
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.view-wrap {
    margin: 12px;
    padding: 15px 17px;
    border-radius: 5px;
    background-color: #FFFFFF;

    .view-wrap-item {
        display: flex;
        line-height: 36px;
        font-size: 15px;

        .wrap-item-label {
            color: #999999;
            float: left;
        }
        .wrap-item-value {
            flex: 1;
            margin-left: 15px;
            color: #000000;
        }
    }
}
</style>